import React from 'react';
import PropTypes from 'prop-types';

function IconCart({ stroke, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      id="basket-1"
      className="cart-icon"
      stroke={stroke}
      strokeWidth="2"
      height={height}
    >
      <path data-name="layer1" fill="none" d="M6.1 27L12 57h40l6-30" />
      <path data-name="layer2" fill="none" d="M26 7L8.1 27M38 7l18 20" />
      <path
        data-name="layer1"
        fill="none"
        d="M2 27h60m-30 8v14M20 35v14m24-14v14"
      />
    </svg>
  );
}

IconCart.propTypes = {
  stroke: PropTypes.string,
  height: PropTypes.number,
};

IconCart.defaultProps = {
  stroke: 'black',
  height: 25,
};

export default IconCart;
